<template></template>
<script>
export default {
    name    :   'PosHandler',
    data()
    {
        return {
            ypos    :   0,
            anchor  :   null
        };
    },
    mounted()
    {
        this.$bus.$on('onWindowScroll', this.handle_scroll);
        this.anchor =   $(this.$el).data('anchor');
        this.$nextTick().then(() => {
            this.ypos   =   $(this.$el).offset().top;
        });
    },
    beforeDestroy()
    {
        this.$bus.$off('onWindowScroll', this.handle_scroll);
    },
    methods :   {
        handle_scroll(offset)
        {
            if (this.$route.path != '/') return false;
            if (offset == 0) {
                this.$bus.$emit('onActivySectionChange', this.anchor, 'pop');
            } else {
                this.ypos   =   $(this.$el).offset().top;
                if (offset + $('#header').outerHeight() >= this.ypos) {
                    this.$bus.$emit('onActivySectionChange', this.anchor, 'push');
                } else if (offset + $(window).height() > this.ypos) {
                    this.$bus.$emit('onActivySectionChange', this.anchor, 'pop');
                }
            }

        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/PosHandler.vue